/**
 * Les Parisiennes — Theme JavaScript Core
 * Shared helpers, delegated actions, and global initialization order.
 */

(function () {
  'use strict';
  /* Global HTML escape helper — prevents XSS in innerHTML contexts */
  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
  }

  function safeStorageGet(key) {
    try { return window.localStorage ? localStorage.getItem(key) : null; }
    catch (e) { return null; }
  }

  function safeStorageSet(key, value) {
    try {
      if (window.localStorage) localStorage.setItem(key, value);
    } catch (e) {}
  }

  var activeFocusTrap = null;

  function getFocusableElements(container) {
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll('a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (el) {
      if (el.closest && el.closest('[inert]')) return false;
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });
  }

  function activateFocusTrap(container, preferredFocus) {
    if (!container) return;
    if (activeFocusTrap && activeFocusTrap.container === container) return;
    if (activeFocusTrap) deactivateFocusTrap(activeFocusTrap.container, false);
    var opener = document.activeElement;
    var handler = function (e) {
      if (e.key !== 'Tab') return;
      var focusable = getFocusableElements(container);
      if (!focusable.length) {
        e.preventDefault();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    container.addEventListener('keydown', handler);
    activeFocusTrap = { container: container, opener: opener, handler: handler };
    setTimeout(function () {
      var target = preferredFocus || getFocusableElements(container)[0];
      if (target && target.focus) {
        try { target.focus({ preventScroll: true }); }
        catch (e) { target.focus(); }
      }
    }, 60);
  }

  function deactivateFocusTrap(container, restoreFocus) {
    if (!activeFocusTrap || activeFocusTrap.container !== container) return;
    container.removeEventListener('keydown', activeFocusTrap.handler);
    var opener = activeFocusTrap.opener;
    activeFocusTrap = null;
    if (restoreFocus !== false && opener && opener.focus && document.contains(opener)) {
      setTimeout(function () {
        try { opener.focus({ preventScroll: true }); }
        catch (e) { opener.focus(); }
      }, 40);
    }
  }

  function getKlaviyoCompanyId() {
    var id = String(window.__klaviyo_company_id || '').trim();
    return /^[A-Za-z0-9]{6}$/.test(id) ? id : '';
  }

  window.__lpGetKlaviyoCompanyId = getKlaviyoCompanyId;
  window.__lpIsValidEmail = isValidEmail;


  var LPTheme = window.LPTheme = window.LPTheme || {};
  LPTheme.inits = LPTheme.inits || {};
	  LPTheme.initOrder = [
    'initTheme',
    'initAccountSubscribePage',
	    'initFocusModality',
	    'checkAnnouncementState',
    'initStickyHeader',
    'initScrollReveal',
    'initSmoothScroll',
    'initLegalAccordions',
    'initEscapeKey',
    'initLazyLoad',
    'initParallax',
    'initEnhancedAddToCart',
    'initProductRecommendations',
    'initNewsletterForm',
    'initContactValidation',
    'initAddressSelectors',
    'initCountryWelcome',
    'initHeaderControls',
    'initDelegatedActions',
    'initHeaderDropdowns',
    'initHeroVideoPosters',
    'initHeroVideoControls',
    'initHeroSliders',
    'initPredictiveSearch',
    'initFilterForm',
    'initCollectionLoadMore',
    'initScrollToTop',
    'initHelpForm',
    'initProductCardReveal',
    'initCarousels',
    'initProductCardHover',
    'initFysChart',
    'initFloatingControls',
    'initPageSizeGuide',
    'initResponsiveRecalc',
    'refreshCartDrawer',
    'initNewsletterPopup',
    'initPopupSubscribe',
    'initBlogLoadMore'
  ];
  LPTheme.registerInit = function (name, fn) {
    if (!name || typeof fn !== 'function') return;
    LPTheme.inits[name] = fn;
  };
  LPTheme.runInit = function (name) {
    var fn = LPTheme.inits[name];
    if (typeof fn !== 'function') return;
    fn();
  };
  LPTheme.escapeHtml = escapeHtml;
  LPTheme.isValidEmail = isValidEmail;
  LPTheme.safeStorageGet = safeStorageGet;
  LPTheme.safeStorageSet = safeStorageSet;
  LPTheme.activateFocusTrap = activateFocusTrap;
  LPTheme.deactivateFocusTrap = deactivateFocusTrap;
  LPTheme.getKlaviyoCompanyId = getKlaviyoCompanyId;
  LPTheme.route = function (path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return root.replace(/\/?$/, '/') + String(path || '').replace(/^\/+/, '');
  };
  var sizeGuideRows = Array.isArray(window.__lpSizeGuideData) ? window.__lpSizeGuideData : [];
  LPTheme.sizeConv = {};
  LPTheme.sizeOrder = [];
  sizeGuideRows.forEach(function (row) {
    var eu = String(row.eu || '');
    if (!eu) return;
    LPTheme.sizeOrder.push(eu);
    LPTheme.sizeConv[eu] = {
      eu: eu,
      us: String(row.us || ''),
      uk: String(row.uk || ''),
      cm: String(row.cm || '')
    };
  });
  LPTheme.getCurrentSizeMetric = function (root) {
    var activeTab = (root || document).querySelector('.size-metric-tab--active');
    return activeTab ? activeTab.dataset.metric : 'eu';
  };
  LPTheme.convertSize = function (euSize, metric) {
    var size = String(euSize || '');
    var target = metric || 'eu';
    return (LPTheme.sizeConv[size] && LPTheme.sizeConv[size][target]) ? LPTheme.sizeConv[size][target] : size;
  };
  LPTheme.getSizeLabel = function (euSize, metric) {
    var target = metric || LPTheme.getCurrentSizeMetric();
    return target.toUpperCase() + ' ' + LPTheme.convertSize(euSize, target);
  };

  function initAccountSubscribePage() {
    var path = window.location.pathname.replace(/\/+$/, '');
    if (path !== '/account/subscribe' && path !== '/services/account/subscribe') return;
    var main = document.getElementById('main');
    if (!main || main.dataset.accountSubscribeEnhanced === 'true') return;
    main.dataset.accountSubscribeEnhanced = 'true';
    document.body.classList.add('template-account-subscribe');

    var strings = window.lpThemeStrings || {};
    var brandTitle = strings.accountSubscribeBrandTitle || 'Les Parisiennes';
    var brandPattern = /\b(?:atelier\s+)?les\s+parisiennes?\b/gi;
    document.title = (strings.accountSubscribePageTitle || 'Email subscription') + ' - ' + brandTitle;

    var nodes = Array.prototype.slice.call(main.childNodes).filter(function (node) {
      return node.nodeType !== 3 || String(node.nodeValue || '').trim() !== '';
    });
    if (!nodes.length) return;

    var section = document.createElement('section');
    section.className = 'account-subscribe reveal is-visible';
    var inner = document.createElement('div');
    inner.className = 'account-subscribe__inner';
    var eyebrow = document.createElement('p');
    eyebrow.className = 'account-subscribe__eyebrow';
    eyebrow.textContent = strings.accountSubscribeEyebrow || 'Newsletter';
    var content = document.createElement('div');
    content.className = 'account-subscribe__content';

    nodes.forEach(function (node) { content.appendChild(node); });
    main.textContent = '';

    var walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
    var textNode;
    while ((textNode = walker.nextNode())) {
      textNode.nodeValue = String(textNode.nodeValue || '').replace(brandPattern, brandTitle);
    }

    var heading = content.querySelector('h1,h2,h3');
    if (!heading) {
      heading = document.createElement('h1');
      content.insertBefore(heading, content.firstChild);
    }
    var headingKey = String(heading.textContent || '').toLowerCase().replace(/[^a-z]/g, '');
    if (/^lesparisiennes?$/.test(headingKey)) {
      heading.textContent = brandTitle;
    }

    Array.prototype.slice.call(content.querySelectorAll('p,div,span')).forEach(function (el) {
      var normalized = String(el.textContent || '').trim().replace(/\s+/g, ' ');
      if (normalized === 'Thank you for subscribing to our mailing list.') {
        el.textContent = strings.accountSubscribeSuccessText || normalized;
      }
      if (normalized === 'You can unsubscribe at any time.') {
        el.textContent = strings.accountSubscribeUnsubscribeText || normalized;
      }
    });

    Array.prototype.slice.call(content.querySelectorAll('a')).forEach(function (link) {
      link.classList.add('account-subscribe__link');
      if (/unsubscribe/i.test(link.textContent || '') || /unsubscribe/i.test(link.href || '')) {
        link.textContent = strings.accountSubscribeUnsubscribeLink || 'Unsubscribe';
      }
    });

    var actions = document.createElement('div');
    actions.className = 'account-subscribe__actions';
    var continueLink = document.createElement('a');
    continueLink.className = 'btn btn--primary account-subscribe__button';
    continueLink.href = '/collections/all-heels';
    continueLink.textContent = strings.accountSubscribeContinue || 'Continue shopping';
    actions.appendChild(continueLink);

    inner.appendChild(eyebrow);
    inner.appendChild(content);
    inner.appendChild(actions);
    section.appendChild(inner);
    main.appendChild(section);
  }

  LPTheme.registerInit('initAccountSubscribePage', initAccountSubscribePage);

	  function initFocusModality() {
	    if (LPTheme._focusModalityBound) return;
	    LPTheme._focusModalityBound = true;
	    var root = document.documentElement;
	    root.classList.add('using-pointer');
	    window.addEventListener('keydown', function (event) {
	      if (event.key === 'Tab') root.classList.remove('using-pointer');
	    }, true);
	    window.addEventListener('pointerdown', function () {
	      root.classList.add('using-pointer');
	    }, true);
	    document.addEventListener('pointerup', function () {
	      var active = document.activeElement;
	      if (active && active.matches && active.matches('a[href], button')) {
	        setTimeout(function () {
	          if (document.activeElement === active && active.blur) active.blur();
	        }, 0);
	      }
	    }, true);
	  }
	  LPTheme.registerInit('initFocusModality', initFocusModality);
  /* ============================================================
   * 1. SCROLL REVEAL — IntersectionObserver animations
   * ============================================================ */
  /* Track scroll direction globally */
  var _scrollDir = 'down';
  var _lastScrollY = 0;
  (function trackScrollDir() {
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      _scrollDir = y >= _lastScrollY ? 'down' : 'up';
      _lastScrollY = y;
    }, { passive: true });
  })();

  function initScrollReveal() {
    if (document.body && document.body.classList.contains('animations-disabled')) {
      document.querySelectorAll('.reveal, .reveal--scale, .reveal--left, .reveal--right, .stagger > *, .divider, .pagination, .editorial-banner__media, .brand-story__image, .newsletter, .product-info, .product-card').forEach(function (el) {
        el.classList.add('is-visible');
        el.style.opacity = '1';
        el.style.transform = 'none';
        el.style.filter = 'none';
      });
      return;
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('.reveal, .reveal--scale, .reveal--left, .reveal--right, .stagger > *, .divider, .pagination, .editorial-banner__media img, .brand-story__image img, .newsletter__images img, .stagger .product-card__img.is-active').forEach(function (el) {
        el.style.opacity = '1';
        el.style.transform = 'none';
        el.style.filter = 'none';
      });
      return;
    }

    /* Appear only — once visible, stays visible forever */
    function revealOnEnter(entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
        }
      });
    }

    /* Reuse a single shared observer across runs so Theme Editor section
       reloads don't accumulate observers. Per-element flag prevents
       double-observation. */
    if (!LPTheme._revealObs) {
      LPTheme._revealObs = new IntersectionObserver(revealOnEnter, { threshold: 0.1, rootMargin: '60px 0px -40px 0px' });
    }
    if (!LPTheme._staggerObs) {
      LPTheme._staggerObs = new IntersectionObserver(revealOnEnter, { threshold: 0.06, rootMargin: '60px 0px -40px 0px' });
    }
    var revealSel = '.reveal, .reveal--scale, .reveal--left, .reveal--right, .section-header, .divider, .pagination, .editorial-banner__media, .brand-story__image, .newsletter, .product-info';
    document.querySelectorAll(revealSel).forEach(function (el) {
      if (el.__lpRevealObserved) return;
      el.__lpRevealObserved = true;
      LPTheme._revealObs.observe(el);
    });
    document.querySelectorAll('.stagger').forEach(function (el) {
      if (el.__lpStaggerObserved) return;
      el.__lpStaggerObserved = true;
      LPTheme._staggerObs.observe(el);
    });
  }
  function showElementById(id, display) {
    var el = id ? document.getElementById(id) : null;
    if (el) el.style.display = display || 'block';
  }

  function hideElementById(id) {
    var el = id ? document.getElementById(id) : null;
    if (el) el.style.display = 'none';
  }

  /* Class-based show/hide using the .is-hidden utility — preferred for new
     code. Lets the element keep its natural CSS display value. */
  function toggleHidden(idOrEl, hidden) {
    var el = typeof idOrEl === 'string' ? document.getElementById(idOrEl) : idOrEl;
    if (el) el.classList.toggle('is-hidden', !!hidden);
  }
  LPTheme.toggleHidden = toggleHidden;

  function initDelegatedActions() {
    if (LPTheme._delegatedActionsBound) return;
    LPTheme._delegatedActionsBound = true;
    document.addEventListener('click', function (e) {
      var actionEl = e.target.closest('[data-action]');
      var stopEl = e.target.closest('[data-stop-propagation]');
      if (stopEl) {
        e.stopPropagation();
        if (!actionEl || !stopEl.contains(actionEl)) return;
      }
      if (!actionEl) return;

      var action = actionEl.dataset.action;
      var handled = true;

      switch (action) {
        case 'cart-toggle':
          window.toggleCartDrawer();
          break;
        case 'cart-line':
          window.updateCartLine(actionEl.dataset.key || parseInt(actionEl.dataset.line || '0', 10), parseInt(actionEl.dataset.quantity || '0', 10));
          break;
        case 'cart-page-qty':
          window.updateQty(actionEl.dataset.key || parseInt(actionEl.dataset.line || '0', 10), parseInt(actionEl.dataset.quantity || '0', 10));
          break;
        case 'search-toggle':
          window.toggleSearch();
          break;
        case 'scroll-top':
          window.smoothScrollTop();
          break;
        case 'help-toggle':
          window.toggleHelpWidget();
          break;
        case 'country-close':
          window.closeCountryWelcome();
          break;
        case 'country-switch':
          window.switchCountryRecommendation();
          break;
        case 'country-change':
          window.openCountrySelector();
          break;
        case 'newsletter-close':
          window.closeNewsletterPopup();
          break;
        case 'newsletter-open':
          if (typeof window.openNewsletterPopup === 'function') {
            window.openNewsletterPopup({ manual: true, mode: actionEl.dataset.popupMode || 'newsletter' });
          }
          break;
        case 'hero-scroll-next':
          if (typeof window.scrollHeroNext === 'function') window.scrollHeroNext(actionEl);
          break;
        case 'locale-toggle':
          window.toggleLocaleDrawer();
          break;
        case 'mobile-region':
          window.toggleMobileNav();
          setTimeout(window.toggleLocaleDrawer, 300);
          break;
        case 'mobile-group':
          window.toggleMobileGroup(actionEl.parentElement);
          break;
        case 'filter-toggle':
          window.toggleFilterDrawer();
          break;
        case 'filter-group':
          window.toggleFilterGroup(actionEl.parentElement);
          break;
        case 'cookie-preferences':
          window.openCookiePreferences();
          break;
        case 'open-find-size':
          window.openFindYourSize();
          break;
        case 'close-find-size':
          window.closeFindYourSize();
          break;
        case 'size-modal-find-size':
          window.closeSizeModal();
          setTimeout(window.openFindYourSize, 300);
          break;
        case 'fys-tab':
          window.switchFysTab(actionEl);
          break;
        case 'gallery-go':
          window.galleryGoTo(parseInt(actionEl.dataset.index || '0', 10));
          break;
        case 'gallery-nav':
          window.galleryNav(parseInt(actionEl.dataset.dir || '0', 10));
          break;
        case 'lightbox-open':
          window.openLightbox(parseInt(actionEl.dataset.index || '0', 10));
          break;
        case 'lightbox-close':
          window.closeLightbox();
          break;
        case 'lightbox-nav':
          window.lightboxNav(parseInt(actionEl.dataset.dir || '0', 10));
          break;
        case 'card-image-nav':
          window.cardImageNav(actionEl, parseInt(actionEl.dataset.dir || '0', 10));
          break;
        case 'select-color':
          window.selectColor(actionEl);
          break;
        case 'open-size-modal':
          window.openSizeModal();
          break;
        case 'close-size-modal':
          window.closeSizeModal();
          break;
        case 'size-metric':
          window.switchSizeMetric(actionEl);
          break;
        case 'select-size-modal':
          window.selectSizeFromModal(actionEl, e);
          break;
        case 'select-size':
          window.selectSize(actionEl);
          break;
        case 'klaviyo-notify':
          window.klaviyoNotify(actionEl, e);
          break;
        case 'klaviyo-step1':
          window.klaviyoNotifyStep1(actionEl, e);
          break;
        case 'product-waitlist':
          window.productWaitlistSubmit(actionEl, e);
          break;
        case 'accordion-toggle':
          window.toggleAccordion(actionEl.parentElement);
          break;
        case 'toast':
          if (window._showToast) {
            var key = actionEl.dataset.toastKey || '';
            var fallback = actionEl.dataset.toastFallback || '';
            window._showToast((window.lpThemeStrings && window.lpThemeStrings[key]) || fallback, parseInt(actionEl.dataset.toastDuration || '5000', 10));
          }
          break;
        case 'address-add-open':
          showElementById('add-address-form', 'block');
          actionEl.style.display = 'none';
          break;
        case 'address-add-close':
          hideElementById('add-address-form');
          showElementById('add-addr-toggle', 'inline-flex');
          break;
        case 'address-edit-open':
          showElementById(actionEl.dataset.target || '', 'block');
          break;
        case 'address-edit-close':
          hideElementById(actionEl.dataset.target || '');
          break;
        case 'address-delete-confirm':
          if (!window.confirm(actionEl.dataset.confirm || 'Delete this address?')) e.preventDefault();
          handled = false;
          break;
        case 'customer-recover-open':
          toggleHidden('customer-login', true);
          toggleHidden('recover-password', false);
          break;
        case 'customer-login-open':
          toggleHidden('recover-password', true);
          toggleHidden('customer-login', false);
          break;
        default:
          handled = false;
      }

      if (handled) e.preventDefault();
    });
  }

	  /* ============================================================
  /* ============================================================
   * 7. PRODUCT + FAQ ACCORDIONS
   * ============================================================ */
  window.toggleAccordion = function (btn) {
    var item = btn.closest('.product-accordion__item') || btn.closest('.faq-item');
    if (!item) return;
    var wasOpen = item.classList.contains('is-open');
    var parent = item.parentElement;
    if (parent) {
      parent.querySelectorAll('.product-accordion__item.is-open, .faq-item.is-open').forEach(function (sibling) {
        sibling.classList.remove('is-open');
        var content = sibling.querySelector('.product-accordion__content, .faq-item__answer');
        if (content) content.style.maxHeight = null;
      });
    }
    if (!wasOpen) {
      item.classList.add('is-open');
      var content = item.querySelector('.product-accordion__content, .faq-item__answer');
      if (content) content.style.maxHeight = content.scrollHeight + 'px';
    }
  };

  function initLegalAccordions() {
    document.querySelectorAll('[data-legal-accordion]').forEach(function (accordion) {
      var items = accordion.querySelectorAll('.legal-text__item');
      var firstOpen = null;

      items.forEach(function (item) {
        if (item.open) {
          if (!firstOpen) firstOpen = item;
          else item.open = false;
        }

        if (item.__lpLegalAccordionBound) return;
        item.__lpLegalAccordionBound = true;
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          accordion.querySelectorAll('.legal-text__item[open]').forEach(function (sibling) {
            if (sibling !== item) sibling.open = false;
          });
        });
      });
    });
  }

  /* ---- TOAST NOTIFICATION ---- */
  function _showToast(msg, duration, isHTML) {
    duration = duration || 3500;
    var existing = document.querySelector('.lp-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'lp-toast';
    var msgSpan = document.createElement('span');
    msgSpan.className = 'lp-toast__msg';
    if (isHTML) msgSpan.innerHTML = msg; else msgSpan.textContent = msg;
    toast.appendChild(msgSpan);
    var closeBtn = document.createElement('button');
    closeBtn.className = 'lp-toast__close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.textContent = '\u00d7';
    closeBtn.onclick = function () { toast.remove(); };
    toast.appendChild(closeBtn);
    document.body.appendChild(toast);
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ toast.classList.add('lp-toast--visible'); }); });
    setTimeout(function(){ toast.classList.remove('lp-toast--visible'); setTimeout(function(){ toast.remove(); }, 400); }, duration);
  }
  window._showToast = _showToast;
  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents, window.shopMoneyFormat);
    var amount = (cents / 100).toFixed(2);
    var currency = window.shopCurrency || 'EUR';
    var symbols = { 'EUR': '\u20ac', 'USD': '$', 'GBP': '\u00a3', 'CZK': 'K\u010d', 'JPY': '\u00a5', 'CHF': 'CHF ' };
    var symbol = symbols[currency] || currency + ' ';
    if (currency === 'CZK') return amount.replace('.', ',') + '\u00a0' + symbol;
    if (currency === 'EUR') return symbol + amount.replace('.', ',');
    return symbol + amount;
  }
  window.formatMoney = formatMoney;
  LPTheme.formatMoney = formatMoney;
  /* ============================================================
   * 12. SMOOTH SCROLL
   * ============================================================ */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      if (link.__lpSmoothBound) return;
      link.__lpSmoothBound = true;
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (href === '#') return;
        var target = document.querySelector(href);
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }

  /* ============================================================
   * 13. ESCAPE KEY
   * ============================================================ */
  function initEscapeKey() {
    if (LPTheme._escapeBound) return;
    LPTheme._escapeBound = true;
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var search = document.getElementById('search-overlay');
      if (search && search.classList.contains('is-open')) { window.toggleSearch(); return; }
      var cart = document.getElementById('cart-drawer');
      if (cart && cart.classList.contains('is-open')) { window.toggleCartDrawer(); return; }
      var nav = document.getElementById('mobile-nav');
      if (nav && nav.classList.contains('is-open')) { window.toggleMobileNav(); return; }
      var filter = document.getElementById('filter-drawer');
      if (filter && filter.classList.contains('is-open')) { window.toggleFilterDrawer(); return; }
      var locale = document.getElementById('locale-drawer');
      if (locale && locale.classList.contains('is-open')) { window.toggleLocaleDrawer(); return; }
      var fys = document.getElementById('fys-modal');
      if (fys && fys.classList.contains('is-open')) { window.closeFindYourSize(); return; }
      var sizeModal = document.getElementById('size-modal');
      if (sizeModal && sizeModal.classList.contains('is-open')) { window.closeSizeModal(); return; }
      var helpPanel = document.getElementById('help-panel');
      if (helpPanel && helpPanel.classList.contains('is-open')) { window.toggleHelpWidget(); return; }
      var newsletterPopup = document.getElementById('newsletter-popup');
      if (newsletterPopup && newsletterPopup.getAttribute('aria-hidden') === 'false') { window.closeNewsletterPopup(); return; }
      var countryPopup = document.getElementById('country-welcome');
      if (countryPopup && countryPopup.getAttribute('aria-hidden') === 'false') { window.closeCountryWelcome(); }
    });
  }

  /* ============================================================
   * 14. LAZY LOAD FALLBACK
   * ============================================================ */
  function initLazyLoad() {
    if ('loading' in HTMLImageElement.prototype) return;
    var imgs = document.querySelectorAll('img[loading="lazy"]');
    if (!imgs.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
          observer.unobserve(img);
        }
      });
    });
    imgs.forEach(function (img) { observer.observe(img); });
  }

  /* ============================================================
   * 15. PARALLAX
   * ============================================================ */
  function initParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    /* Idempotency guard for Theme Editor section reloads. */
    if (LPTheme._parallaxBound) return;
    var banners = document.querySelectorAll('.parallax-img');
    if (!banners.length) return;
    LPTheme._parallaxBound = true;
    window.addEventListener('scroll', function () {
      requestAnimationFrame(function () {
        banners.forEach(function (bg) {
          var rect = bg.getBoundingClientRect();
          if (rect.bottom > 0 && rect.top < window.innerHeight) {
            var offset = (rect.top - window.innerHeight) * 0.3;
            bg.style.transform = 'translateY(' + offset + 'px) scale(1.08)';
          }
        });
      });
    }, { passive: true });
  }
  /* ============================================================
	   * 23. SCROLL TO TOP
   * ============================================================ */
  window.smoothScrollTop = function () {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, left: 0, behavior: reduced ? 'instant' : 'smooth' });
  };

  function initFloatingControls() {
    if (LPTheme._floatingControlsBound) return;
    LPTheme._floatingControlsBound = true;
    var frame = null;
    function updateClearance() {
      frame = null;
      var clearance = 0;
      var width = document.documentElement.clientWidth || window.innerWidth;
      var height = window.innerHeight;
      document.querySelectorAll('.grecaptcha-badge, .h-captcha, iframe[src*="hcaptcha.com"]').forEach(function (badge) {
        var rect = badge.getBoundingClientRect();
        var style = window.getComputedStyle(badge);
        if (style.visibility === 'hidden' || style.display === 'none' || style.opacity === '0') return;
        // Only floating badges at the bottom right affect our controls, not form widgets or challenges.
        if (rect.width <= 0 || rect.height <= 0 || rect.height > 120 || rect.left < width / 2 || rect.top < height - 140 || rect.top >= height || rect.left >= width) return;
        clearance = Math.max(clearance, Math.min(120, width - rect.left + 8));
      });
      var value = Math.ceil(clearance) + 'px';
      if (document.documentElement.style.getPropertyValue('--floating-captcha-clearance') !== value) {
        document.documentElement.style.setProperty('--floating-captcha-clearance', value);
      }
    }
    function queueUpdate() {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(updateClearance);
    }
    updateClearance();
    window.addEventListener('resize', queueUpdate, { passive: true });
    window.addEventListener('scroll', queueUpdate, { passive: true });
    if (typeof window.MutationObserver === 'function') {
      var observer = new window.MutationObserver(queueUpdate);
      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    }
  }

  function initScrollToTop() {
    var btn = document.getElementById('scroll-top');
    if (!btn) return;
    if (btn.__lpScrollTopBound) return;
    btn.__lpScrollTopBound = true;
    window.addEventListener('scroll', function () {
      if (window.pageYOffset > 400) {
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
    }, { passive: true });
  }

  LPTheme.initScrollReveal = initScrollReveal;
  LPTheme.registerInit('initScrollReveal', initScrollReveal);
  LPTheme.registerInit('initDelegatedActions', initDelegatedActions);
  LPTheme.registerInit('initSmoothScroll', initSmoothScroll);
  LPTheme.registerInit('initEscapeKey', initEscapeKey);
  LPTheme.registerInit('initLazyLoad', initLazyLoad);
  LPTheme.registerInit('initParallax', initParallax);
  LPTheme.registerInit('initScrollToTop', initScrollToTop);
  LPTheme.registerInit('initFloatingControls', initFloatingControls);
  LPTheme.registerInit('initLegalAccordions', initLegalAccordions);

  document.addEventListener('DOMContentLoaded', function () {
    LPTheme.initOrder.forEach(function (name) { LPTheme.runInit(name); });

    /* Safety net: only force-show elements currently in/above viewport (not below fold) */
    setTimeout(function () {
      var vh = window.innerHeight;
      var revealSel = '.reveal:not(.is-visible),.reveal--scale:not(.is-visible),.reveal--left:not(.is-visible),.reveal--right:not(.is-visible),.section-header:not(.is-visible),.divider:not(.is-visible),.pagination:not(.is-visible),.editorial-banner__media:not(.is-visible),.brand-story__image:not(.is-visible),.newsletter:not(.is-visible)';
      document.querySelectorAll(revealSel).forEach(function (el) {
        if (el.getBoundingClientRect().top < vh) el.classList.add('is-visible');
      });
      document.querySelectorAll('.stagger:not(.is-visible)').forEach(function (el) {
        if (el.getBoundingClientRect().top < vh) el.classList.add('is-visible');
      });
    }, 4000);
  });

  /* ============================================================
   * Shopify Theme Editor: re-run inits when a section reloads.
   * Inits must be idempotent — most use querySelectorAll + per-element
   * guards (e.g. wrap.__lpCarouselRefresh) so re-running is safe. This
   * code path only fires inside the Theme Editor (Shopify.designMode)
   * and never on the live storefront, so any extra cost is dev-only.
   * ============================================================ */
  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      LPTheme.initOrder.forEach(function (name) {
        try { LPTheme.runInit(name); } catch (e) { /* swallow per-init errors so the rest still run */ }
      });
    });
    document.addEventListener('shopify:section:unload', function (e) {
      /* Best-effort teardown for known re-bindable refs on the unloaded section. */
      var section = e.target;
      if (!section || !section.querySelectorAll) return;
      section.querySelectorAll('[data-carousel]').forEach(function (wrap) {
        if (wrap.__lpCarouselTeardown) {
          try { wrap.__lpCarouselTeardown(); } catch (err) { /* ignore */ }
        }
        wrap.__lpCarouselRefresh = null;
        wrap.__lpCarouselTeardown = null;
      });
    });
  }
}());
